<img *ngIf="url" [src]="sanitize(url)" />
<div>
	<button mat-raised-button color="primary">{{text}}</button>
	<input class="file-input" type="file" [accept]="accept?.join(',')" (change)="upload($event)">
	<div *ngIf="displayError">{{errorMessage}}</div>
</div>